import Button from "../Button";
import {observer} from "mobx-react-lite";
import {useRef} from "react";


export default observer(function UploadField({children, accept, onChange, multiple = true, ...rest}) {
    const inputRef = useRef(null);
    const handleClick = () => inputRef.current?.click();

    return (
        <>
            <input className="hidden" ref={inputRef} type="file" multiple={multiple} accept={accept}
                   onChange={onChange}/>
            <Button variant="pr" size="m2" {...rest} onClick={handleClick}>
                {'Upload'}
            </Button>
        </>
    );
});